import { useEffect } from 'react';
import { ActionType, ComponentType, logEvent } from '@cbhq/client-analytics';

export function useLogErrorView(name: string, message?: string) {
  useEffect(() => {
    logEvent('error_view_displayed', {
      componentType: ComponentType.page,
      action: ActionType.view,
      view_name: name,
      message,
    });
  }, [name, message]);
}
